/* unplugin-vue-components disabled */import { render } from "./purchase-cart-alert.vue?vue&type=template&id=28603775&scoped=true"
import script from "./purchase-cart-alert.vue?vue&type=script&lang=js"
export * from "./purchase-cart-alert.vue?vue&type=script&lang=js"

import "./purchase-cart-alert.vue?vue&type=style&index=0&id=28603775&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28603775"]])

export default __exports__